import { createFileRoute, Link } from "@tanstack/react-router";
import { guides } from "@/content/guides";
import { Navbar1 } from "@/components/ui/navbar-1";
import { SiteFooter } from "@/components/SiteFooter";

const TITLE = "Guias para colecionadores de vinil | Viny Club";
const DESC =
  "Guias práticos para colecionadores de vinil: como regular o toca-discos, limpar discos de vinil antigos e armazenar a coleção sem danificar.";

export const Route = createFileRoute("/guias/")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: "https://viny.club/guias" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://viny.club/guias" }],
  }),
  component: GuidesIndex,
});

function GuidesIndex() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar1 />
      <main className="mx-auto max-w-3xl px-6 pt-28 pb-16">
        <header className="mb-12">
          <p className="mb-3 text-xs uppercase tracking-[0.18em] text-muted-foreground">
            Guias
          </p>
          <h1 className="text-4xl font-medium leading-[1.05] tracking-tight sm:text-5xl">
            Guias para colecionadores de vinil
          </h1>
          <p className="mt-4 text-base text-muted-foreground">
            Conteúdo prático sobre toca-discos, limpeza e armazenamento de discos de vinil.
            Escrito pra quem coleciona e quer preservar cada LP.
          </p>
        </header>

        <ul className="divide-y divide-border border-y border-border">
          {guides.map((g) => (
            <li key={g.slug}>
              <Link
                to="/guias/$slug"
                params={{ slug: g.slug }}
                className="block py-6 transition-opacity hover:opacity-70"
              >
                <h2 className="text-xl font-medium leading-snug">{g.title}</h2>
                <p className="mt-2 text-sm text-muted-foreground">{g.description}</p>
                <p className="mt-3 text-xs uppercase tracking-[0.14em] text-muted-foreground">
                  {g.readingTime} de leitura
                </p>
              </Link>
            </li>
          ))}
        </ul>
      </main>
      <SiteFooter />
    </div>
  );
}
